import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import EventTrackerPageUI from './EventTrackerPageUI.js'
import EventReviewModal from './EventReviewModal.js'
import ContentPreviewModal from './ContentPreviewModal.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class EventTrackerPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      loading: true,
      events: [],
      error: null,
      showReviewModal: false,
      showPreviewModal: false,
      selectedEvent: null,
      reviewStatus: null,
      isNotificationEnabled: false,
      showConfirmationPopup: false,
      notificationToggleLoading: false,
      currentPage: 1,
      totalPages: 1,
      pageSize: 10 // Or your desired default page size, API example uses 3, let's use 10 for a more common scenario
    }
  }

  // Find an event by id or trackerId
  findEventById = (eventId) => {
    return this.state.events.find(eventData => {
      if (eventData.id === eventId) return true;
      if (eventData.tracker && eventData.tracker.trackerId === eventId) return true;
      return false;
    });
  }

  render() {
    const { 
      showReviewModal, 
      showPreviewModal, 
      selectedEvent, 
      reviewStatus, 
      isNotificationEnabled, 
      showConfirmationPopup,
      notificationToggleLoading 
    } = this.state;
    
    return (
      <>
        <EventTrackerPageUI
          context={this.props.context}
          account={this.state.account}
          events={this.state.events}
          loading={this.state.loading}
          error={this.state.error}
          onRefreshClick={this.onRefreshClick}
          onViewEvent={this.handleViewEvent}
          onApproveEvent={this.handleApproveEvent}
          onRejectEvent={this.handleRejectEvent}
          isNotificationEnabled={isNotificationEnabled}
          onNotificationToggle={this.handleNotificationToggle}
          showConfirmationPopup={showConfirmationPopup}
          onConfirmNotification={this.handleConfirmNotification}
          onCancelNotification={this.handleCancelNotification}
          notificationToggleLoading={notificationToggleLoading}
          onDownload={this.handleDownload}
          currentPage={this.state.currentPage}
          totalPages={this.state.totalPages}
          onPageChange={this.handlePageChange}
        />
        
        {showReviewModal && selectedEvent && (
          <EventReviewModal
            context={this.props.context}
            event={selectedEvent}
            reviewStatus={reviewStatus}
            onClose={this.handleCloseReviewModal}
            onSubmit={this.handleSubmitReview}
          />
        )}

        {showPreviewModal && selectedEvent && (
          <ContentPreviewModal
            context={this.props.context}
            event={selectedEvent}
            onClose={this.handleClosePreviewModal}
          />
        )}
      </>
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccount(context)
  }

  getAccount(context) {
    console.log("this.props", this.props)
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Account(this.props.match.params.accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    // Get the account and also set the notification status based on emiNotificationDisabled
    const account = response.account
    const isNotificationEnabled = account && !account.emiNotificationDisabled
    
    this.setState({ 
      account: account,
      isNotificationEnabled: isNotificationEnabled
    })
    
    this.getEvents(this.props.context, 1)
  }

  getEvents = (context, pageNumber) => {
    const accountId = this.props.match.params.accountId;
    const { pageSize } = this.state;
    this.setState({ loading: true });
    // Call the API to fetch events for this account with pagination
    RestApiUtils.get(
      context,
      `/api/v1/notify-event-tracker/getTrackersWithEventsAndTemplatesByAccountIdPagination/${accountId}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      this.handleEventsResponse,
      this.handleEventsError
    );
  }

  handleEventsResponse = (data) => {
    const events = data.trackers || [];
    this.setState({
      events: events,
      loading: false,
      error: null,
      totalPages: data.totalPages || 1,
      currentPage: data.currentPage || 1
    });
  }

  handleEventsError = (error) => {
    console.error('Error getting events:', error)
    this.setState({
      loading: false,
      error: 'Failed to load events. Please try again later.'
    })
  }

  onRefreshClick = () => {
    this.getAccount(this.props.context)
  }

  handleViewEvent = (eventId) => {
    const selectedEvent = this.findEventById(eventId)
    if (selectedEvent) {
      this.setState({
        selectedEvent,
        showPreviewModal: true
      })
    }
  }

  handleDownload = (url) => {
    if (!url) {
      console.error('No file URL provided for download');
      return;
    }

    // First fetch the S3 preview URL
    this.setState({ isDownloading: true });
    
    const payload = {
      path: url
    };
    
    RestApiUtils.post(
      this.props.context,
      '/api/s3/preview',
      (response) => {
        this.setState({ isDownloading: false });
        
        if (response && response.success === 'success' && response.signedUrl) {
          
          // Open the signed URL in a new tab
          window.open(response.signedUrl, '_blank');
        } else {
          console.error('Failed to get S3 preview URL for download', response);
          // Could add a toast or notification here to inform the user
        }
      },
      payload
    );
  }

  handleClosePreviewModal = () => {
    this.setState({
      showPreviewModal: false
    })
  }

  handleApproveEvent = (eventId) => {
    // Find the selected event
    const selectedEvent = this.state.events.find(eventData => {
      // Depending on your data structure, you might need to adjust this
      // If your events array contains the transformed data
      if (eventData.id === eventId) return true;
      // If your events array contains the raw API response
      if (eventData.tracker && eventData.tracker.trackerId === eventId) {
        const trackerData = eventData.tracker;
        // Transform the data for the modal
        return {
          id: trackerData.trackerId,
          name: (trackerData.event && trackerData.event.eventName) ? trackerData.event.eventName : 'Unknown Event',
          timestamp: trackerData.createdAt,
          status: trackerData.status,
          reviewStatus: trackerData.reviewStatus,
          reviewReason: trackerData.reviewReason
        };
      }
      return false;
    });

    // Open the review modal for approval
    this.setState({
      showReviewModal: true,
      selectedEvent: selectedEvent,
      reviewStatus: 'APPROVE'
    });
  }

  handleRejectEvent = (eventId) => {
    // Find the selected event
    const selectedEvent = this.state.events.find(eventData => {
      // Depending on your data structure, you might need to adjust this
      // If your events array contains the transformed data
      if (eventData.id === eventId) return true;
      // If your events array contains the raw API response
      if (eventData.tracker && eventData.tracker.trackerId === eventId) {
        const trackerData = eventData.tracker;
        // Transform the data for the modal
        return {
          id: trackerData.trackerId,
          name: (trackerData.event && trackerData.event.eventName) ? trackerData.event.eventName : 'Unknown Event',
          timestamp: trackerData.createdAt,
          status: trackerData.status,
          reviewStatus: trackerData.reviewStatus,
          reviewReason: trackerData.reviewReason
        };
      }
      return false;
    });

    // Open the review modal for rejection
    this.setState({
      showReviewModal: true,
      selectedEvent: selectedEvent,
      reviewStatus: 'REJECT'
    });
  }
  
  handleCloseReviewModal = () => {
    this.setState({
      showReviewModal: false,
      selectedEvent: null,
      reviewStatus: null
    });
  }

  handleSubmitReview = (reviewData) => {
    console.log('Submitting review:', reviewData);
    
    // Call the new API endpoint
    RestApiUtils.post(
      this.props.context,
      '/api/v1/notify-event-tracker/review-user-response',
      this.onReviewSubmitSuccess,
      reviewData
    );
  }

  handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= this.state.totalPages && newPage !== this.state.currentPage) {
      this.getEvents(this.props.context, newPage);
    }
  }

  onReviewSubmitSuccess = (response) => {
    console.log('Review submitted successfully:', response);
    if (response && response.success === "success") {
      // Close the modal
      this.handleCloseReviewModal();
      // Refresh events after submission, fetch the current page again
      this.getEvents(this.props.context, this.state.currentPage);
    } else {
      console.error('Failed to submit review:', response.errorList);
    }
  }
  
    // Method to check if notifications are enabled
    // This is now handled in getAccountCallback, but keeping for future use if needed
    checkNotificationStatus = (context) => {
      if (this.state.account) {
        const isNotificationEnabled = !this.state.account.emiNotificationDisabled
        this.setState({ isNotificationEnabled: isNotificationEnabled })
      }
    }
  
    // Handle notification toggle click
    handleNotificationToggle = () => {
      this.setState({ showConfirmationPopup: true })
    }
  
    // Handle confirmation popup cancel
    handleCancelNotification = () => {
      this.setState({ showConfirmationPopup: false })
    }
  
    // Handle confirmation popup confirm
    handleConfirmNotification = () => {
      const { isNotificationEnabled } = this.state
      const newStatus = !isNotificationEnabled
      
      // The API parameter is for disabling notifications, so we need to invert our "enabled" status
      const disableNotification = !newStatus
      
      // Set loading state
      this.setState({ notificationToggleLoading: true, showConfirmationPopup: false })
      
      // Make API call to enable/disable notifications
      RestApiUtils.put(
        this.props.context,
        `/api/su/accounts/enableEmiNotification/${this.props.match.params.accountId}/${disableNotification}`,
        (response) => {
          // Success callback
          this.setState({
            isNotificationEnabled: newStatus,
            notificationToggleLoading: false
          })
        },
        (error) => {
          // Error callback
          console.error('Error toggling notification:', error)
          this.setState({
            notificationToggleLoading: false,
            error: 'Failed to update notification settings. Please try again.'
          })
        },
        null // No body needed for this API
      )
    }
}

export default withRouter(EventTrackerPageSF)
